import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
export function ValueStack() {
  return <section className="bg-cream-50 py-8 md:py-12" data-id="element-357">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-358">
        <h2 className="text-2xl md:text-3xl font-bold text-navy-900 mb-6 text-center" data-id="element-359">
          Mirá lo que te llevás hoy:
        </h2>

        <div className="bg-white rounded-xl shadow-lg border border-orange-100 overflow-hidden" data-id="element-360">
          <div className="p-4 md:p-6 space-y-3" data-id="element-361">
            {/* Main Product */}
            <div className="flex items-center gap-3 pb-3 border-b border-gray-100" data-id="element-362">
              <div className="bg-green-100 p-1.5 rounded-full" data-id="element-363">
                <CheckIcon className="w-4 h-4 text-green-600" data-id="element-364" />
              </div>
              <span className="text-sm font-semibold text-navy-900" data-id="element-365">
                Mascota Sola: Guía Anti-Destrucción
              </span>
            </div>

            {/* Bonus 1 */}
            <div className="flex items-center gap-3 pb-3 border-b border-gray-100" data-id="element-366">
              <div className="bg-orange-100 p-1.5 rounded-full" data-id="element-367">
                <GiftIcon className="w-4 h-4 text-orange-600" data-id="element-368" />
              </div>
              <span className="text-sm text-gray-800" data-id="element-369">
                Bono 1: Kit Express de Salida Sin Drama
              </span>
              <span className="ml-auto text-xs font-medium text-green-700 bg-green-50 px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-370">
                Incluido
              </span>
            </div>

            {/* Bonus 2 */}
            <div className="flex items-center gap-3 pb-3 border-b border-gray-100" data-id="element-371">
              <div className="bg-orange-100 p-1.5 rounded-full" data-id="element-372">
                <GiftIcon className="w-4 h-4 text-orange-600" data-id="element-373" />
              </div>
              <span className="text-sm text-gray-800" data-id="element-374">
                Bono 2: Checklist Casa Calma en 15 Min
              </span>
              <span className="ml-auto text-xs font-medium text-green-700 bg-green-50 px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-375">
                Incluido
              </span>
            </div>

            {/* Bonus 3 */}
            <div className="flex items-center gap-3 pb-3 border-b border-gray-100" data-id="element-376">
              <div className="bg-orange-100 p-1.5 rounded-full" data-id="element-377">
                <GiftIcon className="w-4 h-4 text-orange-600" data-id="element-378" />
              </div>
              <span className="text-sm text-gray-800" data-id="element-379">
                Bono 3: Recetario de Enfoque y Masticación
              </span>
              <span className="ml-auto text-xs font-medium text-green-700 bg-green-50 px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-380">
                Incluido
              </span>
            </div>

            {/* Final Price */}
            <div className="flex items-center justify-between bg-orange-50 p-4 rounded-lg border border-orange-200 mt-2" data-id="element-381">
              <span className="text-lg font-bold text-navy-900" data-id="element-382">
                Tu inversión hoy
              </span>
              <span className="text-2xl font-bold text-orange-600" data-id="element-383">
                $14.590 ARS
              </span>
            </div>
          </div>

          <div className="bg-navy-900 text-white px-4 py-4 text-center" data-id="element-384">
            <p className="text-sm font-medium" data-id="element-385">
              Todo lo que necesitás para que tu perro se quede solo con menos
              ansiedad y más calma.
            </p>
            <p className="text-orange-300 text-xs mt-1" data-id="element-386">
              Desde el primer día que aplicás la rutina.
            </p>
          </div>
        </div>
      </div>
    </section>;
}